import { createI18n } from 'vue-i18n';
import datetimeFormats from '@shared/locales/datetimeFormats';
import numberFormats from '@shared/locales/numberFormats';

function loadLocaleMessages() {
	const locales = require.context('@shared/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
	const messages: Record<string, Record<string, string>> = {};

	locales.keys().forEach((key) => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i);

		if (matched && matched.length > 1) {
			const locale = matched[1];
			messages[locale] = locales(key);
		}
	});
	return messages;
}

export default createI18n({
	legacy: false, // needs to be false to use composition api https://vue-i18n.intlify.dev/guide/advanced/composition.html#basic-usage
	locale: process.env.VUE_APP_I18N_LOCALE || 'en',
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
	messages: loadLocaleMessages(),
	datetime: datetimeFormats,
	number: numberFormats,
});
